import React from 'react';
import Modal from 'react-modal';
import './CustomModal.css';

const CustomModal = ({ isOpen, onClose, headerContent, bodyContent, footerContent, modalClassName }) => {
  const combinedModalClassName = `modal-base ${modalClassName || ""}`.trim();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      overlayClassName="modal-overlay"
      className={combinedModalClassName}
    >
      {headerContent && <div className="modal-header">{headerContent}</div>}
      <div className="modal-body">{bodyContent}</div>
      {footerContent && <div className="modal-footer">{footerContent}</div>}
    </Modal>
  );
};

export default CustomModal;
